import React, {Component} from 'react';
import {Link} from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {FaTrash, FaEdit, FaEye, FaCog} from "react-icons/fa";
import {Dropdown} from "react-bootstrap";

class ProxyUsingInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            description: '',
            isChangeDescription: false,
        }
    }


    loadStatus = () => {
        if ( this.props.service.status === 'on' ) {
            return (
                <span className={ "text-success " + this.props.service.status}>
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status === 'off' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status === 'admin_off' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status === 'progressing' || this.props.service.status === 'waiting' ) {
            return (
                <span className={ "text-info status-" + this.props.service.status}>
                    Đang tạo
                </span>
            )
        }
        else if ( this.props.service.status === 'reboot' ) {
            return (
                <span className={ "text-info status-" + this.props.service.status}>
                    Đang cài lại
                </span>
            )
        }
        else if ( this.props.service.status === 'reset_password' ) {
            return (
                <span className={ "text-info status-" + this.props.service.status}>
                    Đang đặt lại mật khẩu
                </span>
            )
        }
        else if ( this.props.service.status === 'change_ip' ) {
            return (
                <span className={ "text-info status-" + this.props.service.status}>
                    Đang đổi IP
                </span>
            )
        }
        else if ( this.props.service.status === 'expire' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status === 'cancel' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status === 'delete' ) {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status === 'change_user' ) {
            return (
                <span className={ "text-primary status-" + this.props.service.status}>
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className={ "text-danger status-" + this.props.service.status}>
                    Chưa tạo
                </span>
            )
        }
    }

    checkedService = (event) => {
        if ( event.nativeEvent.shiftKey ) {
            let value = event.target.checked;
            this.props.checkedServiceShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedService( this.props.actionKey );
        }
    }

    changeAutoRenewOn = () => {
        // console.log(this.props.actionKey)
        this.props.changeAutoRenew( this.props.actionKey, 'on' )
    }

    changeAutoRenewOff = () => {
        // console.log(this.props.actionKey)
        this.props.changeAutoRenew( this.props.actionKey, 'off' )
    }

    testThoi = () => {

    }

    changeText = (event) => {
        this.setState({
            description: event.target.value
        })
    }

    submitChangeDescription = () => {
        this.setState({
            isChangeDescription: !this.state.isChangeDescription
        })
        this.props.submitChangeDescription( this.props.actionKey, this.state.description );
    }

    loadDescription = () => {
        if ( this.state.isChangeDescription ) {
            return (
                <>
                    <div className="form-group form-descripton">
                        <textarea rows="5" cols="12" maxLength="40" className="form-control" name="description" onChange={ this.changeText } />
                        <button type="button" name="button" className="close btn-close"
                                onClick={ () => this.changeDescription() }
                        >
                            <span>×</span>
                        </button>
                    </div>
                    <div className="text-right mt-2">
                        <button type="button" name="button" className="btn mr-1 btn-primary"
                                onClick={ () => this.submitChangeDescription() }
                        >
                            Thay đổi
                        </button>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    { this.props.service.description }
                    <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Ghi chú
                            </Tooltip>
                        )}
                        placement="top"
                    >
                        <span className="btn-edit text-muted ml-2" onClick={ () => this.changeDescription() }>
                            <FaEdit />
                        </span>
                    </OverlayTrigger>
                </>
            )
        }
    }

    changeDescription = () => {
        this.setState({
            isChangeDescription: !this.state.isChangeDescription
        })
    }

    render() {
        return (
            <>
                {
                    this.props.service.error === 0 ? (
                        <tr>
                            <td>
                                <input type="checkbox" value="1" checked={this.props.service.checked}  onChange={ this.checkedService } />
                            </td>
                            <td>
                                <Link to={'/dich-vu-proxy/' + this.props.service.id + '/chi-tiet-dich-vu.html'}>{this.props.service.ip}</Link>
                            </td>
                            <td>
                                {this.props.service.port}
                            </td>
                            <td className="container-passwd">
                                <span className="pass_vps mr-2">
                                    {
                                        this.props.service.isShowPassword ? (
                                            <>
                                                { this.props.service.username } <br/>
                                                { this.props.service.password }
                                            </>
                                        ) : (
                                            <>✱✱✱✱✱</>
                                        )
                                    }
                                </span>
                                <button
                                    className="btn btn-sm p-0 m-0 btn-toggle-passwd-vps"
                                    onClick={ () => this.props.tooglePassword(this.props.actionKey) }
                                >
                                    <FaEye />
                                </button>
                            </td>
                            <td>
                                { this.props.service.text_state }
                            </td>
                            <td>
                                { this.props.service.text_create_date }
                            </td>
                            <td>
                                {
                                    this.props.service.isExpire || this.props.service.expired ? (
                                        <>
                                            <span className="text-danger">{ this.props.service.text_next_due_date } </span>
                                            -
                                            <span className="text-danger"> { this.props.service.text_day }</span>
                                        </>
                                    ) : (
                                        <>
                                            { this.props.service.text_next_due_date } - { this.props.service.text_day }
                                        </>
                                    )
                                }
                            </td>
                            <td>
                                { this.props.service.text_total_time }
                            </td>
                            <td>
                                { this.props.service.text_billing_cycle }
                            </td>
                            <td>
                                { this.props.service.text_amount }
                            </td>
                            <td>
                                {
                                    this.props.service.auto_refurn ? (
                                        <div className="form-group input-custom-switch">
                                            <OverlayTrigger
                                                delay={{ hide: 450, show: 300 }}
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        Tắt tự động gia hạn
                                                    </Tooltip>
                                                )}
                                                placement="top"
                                            >
                                                <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                    <input type="checkbox" className="custom-control-input btnHiddenState" id="customSwitch3"
                                                           checked={ this.props.service.auto_refurn }
                                                           defaultValue={ this.props.service.auto_refurn }
                                                           onChange={ this.testThoi }
                                                    />
                                                    <label className="custom-control-label" htmlFor="customSwitch3"
                                                           onClick={ this.changeAutoRenewOff } />
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    ) : (
                                        <div className="form-group input-custom-switch">
                                            <OverlayTrigger
                                                delay={{ hide: 450, show: 300 }}
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        Bật tự động gia hạn
                                                    </Tooltip>
                                                )}
                                                placement="top"
                                            >
                                                <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                                    <input type="checkbox" className="custom-control-input btnHiddenState" id="customSwitch3"
                                                           checked={ this.props.service.auto_refurn }
                                                           defaultValue={ this.props.service.auto_refurn }
                                                           onChange={ this.testThoi }
                                                    />
                                                    <label className="custom-control-label" htmlFor="customSwitch3"
                                                           onClick={ this.changeAutoRenewOn }/>
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    )
                                }
                            </td>
                            <td>
                                { this.loadDescription() }
                            </td>
                            <td>
                                { this.loadStatus() }
                            </td>
                            <td>
                                {
                                    this.props.service.status !== 'Pending' ? (
                                        <>
                                            <OverlayTrigger
                                                delay={{ hide: 450, show: 300 }}
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        Hành động
                                                    </Tooltip>
                                                )}
                                                placement="top"
                                            >
                                                <Dropdown className="btn mr-1 mb-1 p-0">
                                                    <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn-sm">
                                                        <FaCog />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'expire' ) }>Gia hạn</Dropdown.Item>
                                                        {
                                                            this.props.service.status === 'on' ? (
                                                                <>
                                                                    <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'reboot' ) }>Khởi động lại</Dropdown.Item>
                                                                    <Dropdown.Item onClick={ () => this.props.showModal( this.props.actionKey, 'change_password' ) }>Đổi mật khẩu</Dropdown.Item>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </OverlayTrigger>
                                        </>
                                    ) : (
                                        <></>
                                    )
                                }
                                <OverlayTrigger
                                    delay={{ hide: 450, show: 300 }}
                                    overlay={(props) => (
                                        <Tooltip {...props}>
                                            Hủy Proxy
                                        </Tooltip>
                                    )}
                                    placement="top"
                                >
                                    <button type="button" className="btn btn-danger btn-sm mr-1 mb-1" onClick={ () => this.props.showModal( this.props.actionKey, 'delete' ) }>
                                        <FaTrash />
                                    </button>
                                </OverlayTrigger>
                            </td>
                        </tr>
                    ) : (
                        <tr>
                            <td colSpan={15} className="text-danger text-center">
                                { this.props.service.message }
                            </td>
                        </tr>
                    )
                }
            </>
        );
    }
}

export default ProxyUsingInfo;